import React from "react";
import "./ContactForm.css";
import Button from "../../UI/Button/Button";
import { useWeb3Form } from "../../hooks/useWeb3Form";

const APPOINTMENT_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1uHmQd3vieliyTtHcA_U4Zzs9Si9Evo12FkwP2oYQWihGVDxU_wJYh6J6YZKK8NC9Ha0MoRyQ6";

const ContactForm = () => {
  const { onSubmit, result, submitting } = useWeb3Form("contact");

  return (
    <div className="contact-form uigrid">
      <div className=" uigrid-8 contact-form-box">
        <div className="contact-form-top-inner">
          <h3>Get a quick estimate</h3>
          <p>
            Our time is in GMT +1. We usually respond within 3 hours. Unless
            within 9PM - 7AM
          </p>
        </div>
        <form onSubmit={onSubmit} className="form__contact-form">
          <input type="checkbox" name="botcheck" className="form-botcheck" />
          <div className="contact-form-input-container">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="contact-form-input"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              className="contact-form-input"
              required
            />
            <input
              type="text"
              name="company"
              placeholder="Company Name"
              className="contact-form-input"
            />
            <input
              type="text"
              name="budget"
              placeholder="Budget"
              className="contact-form-input"
            />
            <textarea
              name="message"
              placeholder="Describe your project details here..."
              className="contact-form-text"
              rows="3"
              required
            />
          </div>
          {result && <p className="form-status">{result}</p>}
          <div className="contact__btn-container">
            <button
              type="submit"
              className="uibtn hoverable header-link-btn form-submit-btn"
              disabled={submitting}
            >
              {submitting ? "Sending..." : "Send message"}
            </button>
            <Button
              value="Book an appointment"
              class="header-link-btn"
              href={APPOINTMENT_URL}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
